import { UserRole } from '../enums';
import { useAppSelector } from './redux';

export const useAuth = () => {
  const userRoles = useAppSelector((x) => x.app.userClaims?.roles);
  const isUserInRole = (roles: Array<UserRole>) =>
  !!userRoles && userRoles.some((role) => roles.includes(role));
  return [isUserInRole];
};
